const globalMeta = {
    mainNavEnabled: false,
    topBarEnabled: false,
}
export default [
    {
        path: 'overview',
        name: 'Overview',
        redirect : "helloworld",
    },
    {
        path: 'home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "custom-left-nav-home" */ '../views/Home.vue'),
        meta: globalMeta,
    },
    {
        path: 'testpage',
        name: 'Test Page',
        component: () => import(/* webpackChunkName: "custom-left-nav-testnav" */ '../views/TestNav.vue'),
        meta: globalMeta,
    },
    {
        path: 'testfields',
        name: 'Test Fields',
        component: () => import(/* webpackChunkName: "custom-left-nav-ttesfields" */ '../views/TestFields.vue'),
        meta: globalMeta,
    },     
    {
        path: 'apphelp',
        name: 'App Help',
        component: () => import(/* webpackChunkName: "custom-left-nav-help" */ '../views/Help.vue'),
        meta: globalMeta,
    },
    {
        path: 'config',
        name: 'Config',
        component: () => import(/* webpackChunkName: "custom-left-nav-config" */ '../views/Config.vue'),
        meta: globalMeta,
    },
    {
        path: 'help',
        name: 'Help',
        component: () => import(/* webpackChunkName: "custom-left-nav-global-help" */ '@/_views/Help.vue'),
        meta: globalMeta,
    },   
]
